import maplibregl from 'maplibre-gl'

const { AttributionControl } = maplibregl

export class CustomAttributionControl extends AttributionControl {
  _updateCompact = () => {
    this._container.classList.add('maplibregl-compact')
    if (this._initialCompact) {
      this._container.classList.add('maplibregl-compact-show')
    }
  }

  updateCustomAttributions(attributions) {
    this.options.customAttribution = attributions
    this._updateAttributions()
  }
}
